export enum AllocationType
{
    SUPPLIER = 'SUPPLIER',
    RESOURCE = 'RESOURCE',
    SUPPLIER_OR_RESOURCE = 'SUPPLIER_OR_RESOURCE'
}
